module.exports = __webpack_public_path__ + "static/anika_jagow-3be148c14a28ad1c8ed8d09079793517.pdf";